import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Button } from '@skupreme/shared/ui';
import { LoaderBar } from '@components/LoaderBar';
import { DateFormField } from '@elements/FormField';
import { AppModal } from '@elements/Modal';
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessageConstant } from '@utility/constants/common';
import PurchaseOrdersService from '@utility/services/purchase-order';
import { ToastMessage } from '@utility/toast';

const poStatusSchema = yup.object().shape({
  estimated_completion: yup
    // @ts-expect-error - TS2554: Expected 0 arguments, but got 1.
    .date('Date is Required Field')
    .typeError('Date is Required Field')
    .required('Date is Required Field'),
});

export function ChangeETAPopup({ open, closeModal, data, id }) {
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(poStatusSchema),
    shouldUnregister: true,
  });

  const [processing, setProcessing] = useState('');

  useEffect(() => {
    if (open) {
      /* @ts-expect-error - TS2322: Type 'null' is not assignable to type 'undefined'. */
      reset({ status: null });
    }
  }, [open, data]);

  const onSubmit = async formData => {
    try {
      setProcessing('Updating ETA');
      await PurchaseOrdersService.changeETA(id, formData);
      closeModal(true);
    } catch (error) {
      ToastMessage.error(error.error || ErrorMessageConstant.defaultAPIError);
    } finally {
      setProcessing('');
    }
  };

  return (
    <AppModal
      open={open}
      title="Change Est. Completion"
      closeModal={closeModal}
    >
      {processing && <LoaderBar content={processing} />}
      <form
        autoComplete="off"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        className="sk:flex sk:flex-col"
      >
        <DateFormField
          error={errors.estimated_completion}
          hint={errors.estimated_completion?.message}
          label="New Date"
          placeholder="Select Date"
          name="estimated_completion"
          defaultValue=""
          minDate={new Date()}
          control={control}
          required
          className="sk:w-full"
          width={16}
        />
        <div className="sk:flex sk:justify-end sk:gap-2">
          <Button onPress={() => closeModal()}>Cancel</Button>
          <Button type="submit" variant="primary">
            Submit
          </Button>
        </div>
      </form>
    </AppModal>
  );
}
